/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search-user': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M426.667 85.333C332.41 85.333 256 161.743 256 256s76.41 170.667 170.667 170.667c94.256 0 170.666-76.41 170.666-170.667S520.923 85.333 426.667 85.333zm0 426.667C167.38 512 85.333 682.667 85.333 682.667V768H464c-10.41-26.496-16-55.21-16-85.333 0-63.531 25.493-121.718 66.667-164-26.752-4.566-56-6.667-88-6.667zm256 0C588.915 512 512 588.915 512 682.667c0 93.75 76.915 170.666 170.667 170.666 31.25 0 60.049-9.133 85.333-24l97.333 97.334 61.334-61.334L829.333 768c14.867-25.284 24-54.083 24-85.333 0-93.752-76.915-170.667-170.666-170.667zm0 85.333c47.633 0 85.333 37.7 85.333 85.334C768 730.3 730.3 768 682.667 768c-47.634 0-85.334-37.7-85.334-85.333 0-47.634 37.7-85.334 85.334-85.334z"/>'
  }
})
